import React, { Component } from "react";
import "../../style/common/popup.scss";
import Tip from "../../icon/Tip";
class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popState: false,
      popMsg: false,
    };
  }

  alertModalTimeoutInterval = null;

  componentDidMount() {
    window.addEventListener("showAlert", (event) => {
      this.setState({
        popState: true,
        popMsg: event && event.detail,
      });
      if (this.alertModalTimeoutInterval) {
        window.clearTimeout(this.alertModalTimeoutInterval);
      }
      this.alertModalTimeoutInterval = window.setTimeout(() => {
        this.setState({ popState: false, popMsg: "" });
      }, 3000);
      console.log(event);
    });
  }

  componentWillUnmount() {
    if (this.alertModalTimeoutInterval) {
      window.clearTimeout(this.alertModalTimeoutInterval);
    }
  }

  render() {
    const { popMsg, popState } = this.state;
    return (
      <div className={`pop-box ${popState ? "pop-show" : ""} `}>
        <h4>
          <Tip size={20} color="#f77167"/>
          <p>{popMsg}</p>
        </h4>
      </div>
    );
  }
}

export default Popup;
